import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import Home from '../containers/app/Home';


export default function(params) {
  return (
    <React.Fragment>
      <PageWrapper>
        <Home />
      </PageWrapper>
    </React.Fragment>
  );
};
